import store from '@/store'

let guard = (context) => new Promise((resolve, reject) => {
  let account = store.getters['auth/account']
  let subscription = account.subscription

  if(subscription && subscription.status === 'active') {
    resolve()
    return
  }

  if(new Date(account.expires_at) > new Date) {
    resolve()
    return
  }

  reject({
    name: 'plans',
  })
})

export default {
  name: 'active-subscriber',
  run: guard
}
